import { type CSSProperties, type ReactNode } from 'react'
import clsx from 'clsx'

export function Card({
  children,
  className,
  onClick,
  as = 'div',
  style,
}: {
  children: ReactNode
  className?: string
  soft?: boolean
  onClick?: () => void
  as?: 'div' | 'button'
  style?: CSSProperties
}) {
  const Tag = as
  return (
    <Tag
      onClick={onClick}
      style={style}
      className={clsx('block text-left w-full', onClick && 'tap', className)}
    >
      {children}
    </Tag>
  )
}

export function Notice({
  title,
  children,
}: {
  title: string
  children: ReactNode
  tone?: 'blue' | 'orange'
}) {
  return (
    <div className="block-inv p-4">
      <div className="display text-[14px]">{title}</div>
      <div className="text-[13px] leading-relaxed mt-2 mono" style={{ opacity: 0.85 }}>{children}</div>
    </div>
  )
}

export function Divider() {
  return <div className="rule w-full" />
}
